var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKnowledge = function SvgKnowledge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.905 1.843c-.249 0-.967.02-1.905.185V0S9.41.08 7.087 2.833c0 0-2.292-1.594-6.572-1.594q-.253 0-.515.007v12.486c3.566.036 5.955.777 8 2.03 0 0 2.816-1.809 7-1.87V1.845l-.095-.001zM11.5 1.778v8.866c-.977.38-2.38 1.098-3.5 2.312v-8.88l.233-.276c.979-1.16 2.27-1.736 3.267-2.022m-10 .993c3.063.202 4.722 1.288 4.73 1.293l.27.188v9.11c-1.5-.588-3.122-.945-5-1.073V2.77z"
  })));
};
export default SvgKnowledge;